import palette from './palette';
import typography from './typography';
import colours from './colours';
import layout from './layout';
import { dropdownMenu, header, button } from './overrides';

export default {
  palette,
  typography,
  colours,
  layout,
  dropdownMenu,
  header,
  button
};
